import { render, staticRenderFns } from "./HealthBlock.vue?vue&type=template&id=b660e77a&"
import script from "./HealthBlock.vue?vue&type=script&lang=js&"
export * from "./HealthBlock.vue?vue&type=script&lang=js&"
import style0 from "./HealthBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports